import { render } from "./NavbarMessagesDropdown.vue?vue&type=template&id=c9827c2e&scoped=true"
import script from "./NavbarMessagesDropdown.vue?vue&type=script&lang=js"
export * from "./NavbarMessagesDropdown.vue?vue&type=script&lang=js"

import "./NavbarMessagesDropdown.vue?vue&type=style&index=0&id=c9827c2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9827c2e"]])

export default __exports__